module.exports = __webpack_public_path__ + "img/Partners3.9d1f65ee.png";